import { gatewayInstance } from "../server/gateway";

export interface IToDoItem {
  itemId: string;
  content: string;
  users: any[];
  scheduleId: string;
  taskId: string;
}
export interface ICreateOptions {
  itemId: string;
  meetingId: string;
}

// 获取会议信息及参会人员
export async function queryJRTCConferenceInfo(meetingId: string, type = 0) {
  try {
    const data: any = await gatewayInstance.request({
      api: "conference.queryJRTCConferenceInfo",
      method: "POST",
      body: {
        meetingId,
        type
      }
    });
    return data;
  } catch (error) {
    console.error(error);
    return {};
  }
}

// 获取会议纪要
export async function queryAIMinutes(meetingId: string) {
  try {
    const data: any = await gatewayInstance.request({
      api: "conference.queryAIMinutes",
      method: "POST",
      body: {
        meetingId,
        pageSize: 1000,
        pageNumber: 0
      }
    });
    return data?.data || [];
  } catch (error) {
    console.error(error);
    return [];
  }
}

// 获取会议摘要
export async function queryAISummary(meetingId: string) {
  try {
    const data: any = await gatewayInstance.request({
      api: "conference.queryAISummary",
      method: "POST",
      body: {
        meetingId
      }
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 获取摘要列表
export async function queryMeetingMinutes(options: {
  pageNo: number;
  pageSize: number;
  type?: "all" | "create" | "receive";
}) {
  try {
    // let api = "queryMeetingMinutes";
    let api = "getAllMinutesPermissionPageList";
    if (options.type === "create") {
      api = "getMyCreateMinutesPermissionPageList";
    } else if (options.type === "receive") {
      api = "getMyReceiveMinutesPermissionPageList";
    }
    const data: any = await gatewayInstance.request({
      api: `conference.${api}`,
      method: "POST",
      body: {
        pageNo: options.pageNo,
        pageSize: options.pageSize
      }
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 更新打开时间
export async function updateMinutesOpenTime(bizId: string) {
  try {
    const data: any = await gatewayInstance.request({
      api: "conference.updateMinutesOpenTime",
      method: "POST",
      body: { bizId }
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

export enum MinutesPermission {
  transfer = 4, // 转让
  share = 3, // 分享
  edit = 2, // 编辑
  read = 1 // 阅读
}
export enum MinutesRole {
  creator = 3, // 创建者
  owner = 2, // 所有者
  collaborator = 1 // 协作者
}

export enum ShareUserType {
  user = 1,
  group = 2,
  org = 3
}

export interface MinutesPermissionDto {
  // bizId: string;
  userId?: string;
  deptId?: string;
  groupId?: string;
  teamId?: string;
  appId?: string;
  role: MinutesRole;
  permission: MinutesPermission;
  shareUserType: ShareUserType;
}
/**
 * 授权会议纪要
 * @param body
 */
export async function updateMinutesPermission(body: {
  bizId: string;
  userList?: MinutesPermissionDto[];
  groupList?: MinutesPermissionDto[];
  orgList?: MinutesPermissionDto[];
  ignoreAiCard?: boolean;
}) {
  try {
    const data: any = await gatewayInstance.request({
      api: "conference.updateMinutesPermission",
      method: "POST",
      body
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

/**
 * 获取文档权限
 * @param body
 */
export async function getMinutesPermission(body: { bizId: string }) {
  try {
    const data: any = await gatewayInstance.request({
      api: "conference.getMinutesPermission",
      method: "POST",
      body
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 纪要修改
export async function editMinutes(options: any) {
  return gatewayInstance.request({
    api: "conference.editMinutes",
    method: "POST",
    body: options
  });
}

// 会议待办查询
export async function queryToDoItems(meetingId: string): Promise<any> {
  try {
    const data: IToDoItem[] = await gatewayInstance.request({
      api: "conference.queryToDoItems",
      method: "POST",
      body: {
        meetingId
      }
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 创建日程
export async function createMinutesSchedule(opts: ICreateOptions): Promise<any> {
  try {
    const data: any = await gatewayInstance.request({
      api: "conference.createMinutesSchedule",
      method: "POST",
      body: opts
    });
    return [data, null];
  } catch (error) {
    console.log("createMinutesSchedule>error>>", error);
    return [null, error.message.toString()];
  }
}

// 创建任务
export async function createMinutesTask(opts: ICreateOptions): Promise<any> {
  try {
    const data: any = await gatewayInstance.request({
      api: "conference.createMinutesTask",
      method: "POST",
      body: opts
    });
    return [data, null];
  } catch (error) {
    console.log("createMinutesTask>error>>", error);
    return [null, error.message.toString()];
  }
}
